import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormCreateUserByRole from './FormCreateNewUserByRole';
import RCPagination from '../../UserControl/Pagination/RCPagination';
import ModalConfirmUserInformation from '../../../Modals/ModalConfirmUserInformation';
import ModalConfirmDelete from '../../../Modals/ModalConfirmDelete';
import AlertBar from '../../../Modals/AlertBar';
import moment from 'moment';
import { checkStatus } from '../../../../util/util';
import {AlertConfirm, AlertCommit} from '../../../Modals/AlertBar';
import filter from 'lodash/filter';
import { withNamespaces } from 'react-i18next';

class DealerInfo extends Component {
    constructor() {
        super();
        this.state  = {

            deviceList: [],
            dataSelectRow: null,
            isShowEdit: false,
            isShowCreateNewDealer: false,
            currentPage: 1,
            currentPageSize: 10,
            showModalConfirmUserInformation: false,
            ShowDeleteRow: false,
            dataCreateNewUser: {},
            notification: false,
            search:'',
            totalPage: 0,
            apiName: '',
            openList : true,
            // deviceNoList: []
        };
    }

    componentWillMount() {
        const { sideBarName } = this.props
        console.log('sideBarName:', sideBarName);
        if (sideBarName === 'dealerInfo') {
            this.setState({apiName: 'getDealerList'});
        } else if (sideBarName === 'customerInfo') {
            this.setState({apiName: 'getCustomerList'});
        } else if (sideBarName === 'employeeInfo') {
            this.setState({apiName: 'getEmployeeList'});
        } else if (sideBarName === 'adminInfo') {
            this.setState({apiName: 'getAdminList'});
        }
    }

    componentWillReceiveProps(nextProps) {
        const { apiName } = this.state;
        // console.log('nextProps.sideBarName:', nextProps.sideBarName);
        console.log('nextProps.apiName:', apiName);
        if (nextProps.sideBarName !== this.props.sideBarName ) {
            if (nextProps.sideBarName === 'dealerInfo') {
                this.onPageSizeChange(1, this.state.currentPageSize, 'getDealerList');
            } else if (nextProps.sideBarName === 'customerInfo') {
                this.onPageSizeChange(1, this.state.currentPageSize, 'getCustomerList');
            } else if (nextProps.sideBarName === 'employeeInfo') {
                this.onPageSizeChange(1, this.state.currentPageSize, 'employeeList');
            } else if (nextProps.sideBarName === 'adminInfo') {
                this.onPageSizeChange(1, this.state.currentPageSize, 'getAdminList');
            }
        }
    }

    componentDidMount() {
        const { sideBarName,objDeviceUserRelated } = this.props;
        const { apiName } = this.state;
        console.log('apiName:', apiName);
        if (sideBarName === 'dealerInfo') {
            this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize, apiName);
        } else if (sideBarName === 'customerInfo') {
            this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize, apiName);
        } else if (sideBarName === 'employeeInfo') {
            this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize, apiName);
        } else if (sideBarName === 'adminInfo') {
            this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize, apiName);
        }
        // this.getDeviceUserRelated();
        if (objDeviceUserRelated.isOpenDeviceUserRelated) {
            console.log('objDeviceUserRelated.isOpenDeviceUserRelated',objDeviceUserRelated.isOpenDeviceUserRelated)
            this.getUserListById(this.state.currentPage, this.state.currentPageSize, apiName);
        }

    }

    getUserListById(page, pageSize, apiName){
        const { user_id, user_name,token} = this.props;
        const { search } = this.state;

        fetch(`http://203.150.199.244/api/admin/${apiName}/${page}/${9999}` , {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
                "filter":search
            })
            })
            .then(response => { return checkStatus(response)})
            .then(data => {
                this.setState({
                    deviceList:data.RESULT_DATA,
                    currentPage:page,
                    totalPage:data.RESULT_TOTAL,
                    currentPageSize:pageSize
                }, () => {

                    if (this.props.objDeviceUserRelated.isOpenDeviceUserRelated) {

                        this.onOpenEditFromDeviceUserRelated(this.props.objDeviceUserRelated.deviceId);
                        // this.getDeviceListById(this.state.currentPage, this.state.currentPageSize);
                        // this.editeDevice(null);
                        console.log('objDeviceUserRelated',this.props.objDeviceUserRelated.deviceId)

                    }
                })
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });

    }

    componentWillUnmount(){
        console.log('componentWillUnmount:::')
        this.setState({
            currentPage: 1,
            isShowEdit: false,
            isShowCreateNewDealer: false,});
    }

    onPageSelect(page){
        const { currentPageSize,search } = this.state;
        const { user_id, user_name,token,sideBarName} = this.props;
        console.log('sideBarName:', sideBarName);
        let url = '';
        if (sideBarName === 'dealerInfo') {
            url = `http://203.150.199.244/api/admin/getDealerList/${page}/${currentPageSize}`;
        } else if (sideBarName === 'customerInfo') {
            url = `http://203.150.199.244/api/admin/getCustomerList/${page}/${currentPageSize}`;
        } else if (sideBarName === 'employeeInfo') {
            url = `http://203.150.199.244/api/admin/getEmployeeList/${page}/${currentPageSize}`;
        }  else if (sideBarName === 'getAdminList') {
            url = `http://203.150.199.244/api/admin/getAdminList/${page}/${currentPageSize}`;
        }
        fetch(url, {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
                "filter":search
            })
        })
            .then(response => response.json())
            .then(data => {
                this.setState({
                    deviceList:data.RESULT_DATA,
                    currentPage:page,
                    totalPage:data.RESULT_TOTAL,
                    currentPageSize:currentPageSize
                })
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });
    }

    onPageSizeChange(page, pageSize, apiName){
        console.log('pageSize onPageSizeChange:', pageSize);
        const { user_id, user_name,token} = this.props;
        const { search } = this.state;

        if (!page || !apiName){
            page = this.state.currentPage;
            apiName = this.state.apiName;
        }

        fetch(`http://203.150.199.244/api/admin/${apiName}/${page}/${pageSize}` , {
            method: 'post',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                // "user_id": user_id,
                // "user_name": user_name,
                "token": token
            },
            body: JSON.stringify({
                "filter":search
            })
            })
            .then(response => { return checkStatus(response)})
            .then(data => {
                this.setState({
                    deviceList:data.RESULT_DATA,
                    currentPage:page,
                    totalPage:data.RESULT_TOTAL,
                    currentPageSize:pageSize
                })
            })
            .catch(function (err) {
                console.log('err:', err);
                // POST failed...
            });

    }

    onOpenEditFromDeviceUserRelated = (deviceId) => {

        // var array = [...this.state.deviceList];
        // var index = array.indexOf(deviceId)
        // console.log('device index',index)
        // array.splice(index, 1);
        // this.state.competitorList = array;
        // this.state.comps = array;
        // this.setState({
        //     competitorList: array,
        //     comps:array,
        // });

        const device = filter(this.state.deviceList, o => o.user_id === deviceId)

        console.log('this.state.deviceList',this.state.deviceList)
        console.log('device',device)
        this.setState({

            dataSelectRow: device[0],
            isShowEdit: true,
            isShowCreateNewDealer: true,
            notification: false,
            openList:false,
        });
    }

    createNewUserByRole(){
        this.setState({
            isShowCreateNewDealer:true,
            isShowEdit: false,
            openList:false,
        })
    }

    onCloseCreateDealer(){
        this.setState({
            isShowCreateNewDealer:false,
            isShowEdit: false,
            openList:true,
        })
    }

    editeDevice(data) {
        this.setState({
            dataSelectRow: data,
            isShowEdit: true,
            isShowCreateNewDealer: true,
            notification: false,
            openList:false,
        })
    }

    onEditDeviceClose(){
        this.btnEditClose.click();
        this.setState({
            isShowEdit:false
        })
    }

    deleteDevice(data){
        this.setState({
            dataSelectRow: data,
            isShowEdit: false,
            isShowCreateNewDealer: false,
            ShowDeleteRow: true,
            openList:true,
        })

        this.onClickConfirmDelete();
    }

    onValidateComplete = (data) => {
        console.log('data onValidateComplete:', data);
        this.setState({dataCreateNewUser: data}, () => this.onClickConfirmUserInformation());
    }

    onClickCancelUserInformation = (status) => {
        this.setState({showModalConfirmUserInformation: status});
    }

    onClickConfirmUserInformation = () => {
        const { isShowEdit } = this.state;
        console.log('isShowEdit',isShowEdit)
        if (!isShowEdit){
            this.handleCreateDealer();
        } else if (isShowEdit){
            this.handleEditDealer();
        }
    }

    handleCreateDealer = () => {
        console.log('handleCreateDealer')
        const {
            user_name,
            user_id,
            sideBarName,
            token
        } = this.props;

        const { dataCreateNewUser, apiName } = this.state;
        console.log('handleCreateDealer dataCreateNewUser:', dataCreateNewUser);
        if (sideBarName === 'dealerInfo') {

            AlertConfirm("เพิ่มตัวแทนจำหน่าย","คุณต้องการบันทึกข้อมูลหรือไม่").then(isOk=>{
                if(isOk){

                    fetch("http://203.150.199.244/api/admin/newDealer", {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        // "user_id": user_id,
                        // "user_name": user_name,
                        "token": token
                    },
                    body: JSON.stringify({
                        "login_name": dataCreateNewUser.userName,
                        "first_name": dataCreateNewUser.firstName,
                        "last_name": dataCreateNewUser.lastName,
                        "tel_no": dataCreateNewUser.telephone,
                        "email": dataCreateNewUser.email,
                        "company_name": dataCreateNewUser.companyName,
                        "line_api_token": dataCreateNewUser.lineApiToken,
                        "password": dataCreateNewUser.password,
                        "is_send_daily_report": dataCreateNewUser.isSendDailyReport,
                        "is_create_subdealer": dataCreateNewUser.isCreateSubDealer /* new requirement */
                    })
                })
                    .then(response => { return checkStatus(response)})
                    .then((data) => {

                        if(data.RESULT_STATUS == "000")
                                AlertCommit(true,"บันทึกข้อมูลเรียบร้อยแล้ว");
                            else{
                                AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                            }

                        this.setState({
                            // showModalConfirmUserInformation: false,
                            isShowCreateNewDealer: false,
                            openList:true,
                            // notification: true
                        })
                        this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize,apiName)
                    })
                    // .then(() => {
                    //     this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize,apiName)
                    // })
                    .catch(function (err) {
                        console.log('err:', err);
                        // POST failed...
                    });
                }
            });
        } else if (sideBarName === 'customerInfo') {

            AlertConfirm("เพิ่มลูกค้า","คุณต้องการบันทึกข้อมูลหรือไม่").then(isOk=>{
                if(isOk){

                    fetch("http://203.150.199.244/api/admin/newCustomer", {
                        method: 'post',
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            // "user_id": user_id,
                            // "user_name": user_name,
                            "token": token
                        },
                        body: JSON.stringify({
                            "login_name": dataCreateNewUser.userName,
                            "first_name": dataCreateNewUser.firstName,
                            "last_name": dataCreateNewUser.lastName,
                            "tel_no": dataCreateNewUser.telephone,
                            "email": dataCreateNewUser.email,
                            "company_name": dataCreateNewUser.companyName,
                            "password": dataCreateNewUser.password,
                            "is_send_email_alert_overdue": dataCreateNewUser.isSendEmailAlertOverdue,
                            "is_auto_dispermit": dataCreateNewUser.isAutoDispermit,
                            "reseller_note": dataCreateNewUser.resellerNote,
                            "privileges": {
                                "is_view_tracking": dataCreateNewUser.isViewTracking,
                                "is_view_poi": dataCreateNewUser.isViewPoi,
                                "is_edit_poi": dataCreateNewUser.isEditPoi,
                                "is_view_history": dataCreateNewUser.isViewHistory,
                                "is_send_command": dataCreateNewUser.isSendCommand,
                                "is_view_report": dataCreateNewUser.isViewReport
                            }
                        })
                    })
                        .then(response => { return checkStatus(response)})
                        .then((data) => {

                            if(data.RESULT_STATUS == "000")
                                AlertCommit(true,"บันทึกข้อมูลเรียบร้อยแล้ว");
                            else{
                                AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                            }

                        this.setState({
                            // showModalConfirmUserInformation: false,
                            isShowCreateNewDealer: false,
                            openList:true,
                            // notification: true
                        })
                        this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize,apiName)


                        })
                        .catch(function (err) {
                            console.log('err:', err);
                            // POST failed...
                        });
                    }
                });
        } else if (sideBarName === 'employeeInfo') {
            console.log('apiName:', apiName);
            console.log('dataCreateNewUser:', dataCreateNewUser);
            AlertConfirm("เพิ่มพนักงาน","คุณต้องการบันทึกข้อมูลหรือไม่").then(isOk=>{
                if(isOk){

                    fetch("http://203.150.199.244/api/admin/newEmployee", {
                        method: 'post',
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            // "user_id": user_id,
                            // "user_name": user_name,
                            "token": token
                        },
                        body: JSON.stringify({
                            "login_name": dataCreateNewUser.userName,
                            "first_name": dataCreateNewUser.firstName,
                            "last_name": dataCreateNewUser.lastName,
                            "tel_no": dataCreateNewUser.telephone,
                            "email": dataCreateNewUser.email,
                            "company_name": dataCreateNewUser.companyName,
                            "password": dataCreateNewUser.password,
                            "is_send_email_alert_overdue": dataCreateNewUser.isSendEmailAlertOverdue,
                            "is_auto_dispermit": dataCreateNewUser.isAutoDispermit,
                            "reseller_note": dataCreateNewUser.resellerNote
                        })
                    })
                        .then(response => { return checkStatus(response)})
                        .then((data) => {
                            if(data.RESULT_STATUS == "000")
                                AlertCommit(true,"บันทึกข้อมูลเรียบร้อยแล้ว");
                            else{
                                AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                            }

                        this.setState({
                            isShowCreateNewDealer: false,
                            openList:true,
                        })
                        this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize,apiName)
                        })

                        .catch(function (err) {
                            console.log('err:', err);
                            // POST failed...
                        });
                    }
                });
        } else if (sideBarName === 'adminInfo') {

            AlertConfirm("เพิ่มผู้ดูแลระบบ","คุณต้องการบันทึกข้อมูลหรือไม่").then(isOk=>{
                if(isOk){

                    fetch("http://203.150.199.244/api/admin/newAdmin", {
                        method: 'post',
                        headers: {
                            "Content-Type": "application/json; charset=utf-8",
                            // "user_id": user_id,
                            // "user_name": user_name,
                            "token": token
                        },
                        body: JSON.stringify({
                            "login_name": dataCreateNewUser.userName,
                            "first_name": dataCreateNewUser.firstName,
                            "last_name": dataCreateNewUser.lastName,
                            "tel_no": dataCreateNewUser.telephone,
                            "email": dataCreateNewUser.email,
                            "company_name": dataCreateNewUser.companyName,
                            "password": dataCreateNewUser.password
                        })
                    })
                        .then(response => { return checkStatus(response)})
                        .then((data) => {

                            if(data.RESULT_STATUS == "000")
                                AlertCommit(true,"บันทึกข้อมูลเรียบร้อยแล้ว");
                            else{
                                AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                            }

                        this.setState({
                            // showModalConfirmUserInformation: false,
                            isShowCreateNewDealer: false,
                            openList:true,
                            // notification: true
                        })
                        this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize,apiName)
                        })
                        .catch(function (err) {
                            console.log('err:', err);
                            // POST failed...
                        });
                    }
                });
        }
    }

    handleEditDealer = () => {

        const {
            user_name,
            user_id,
            sideBarName,
            token
        } = this.props;
        const { dataCreateNewUser, dataSelectRow, apiName } = this.state;
        console.log('dataCreateNewUser',dataCreateNewUser)
        if (sideBarName === 'dealerInfo') {
            fetch(`http://203.150.199.244/api/admin/updateDealer/${dataSelectRow.user_id}`, {
                method: 'post',
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    // "user_id": '',
                    // "user_name": '',
                    "token": token
                },
                body: JSON.stringify({
                    "login_name": dataCreateNewUser.userName,
                    "first_name": dataCreateNewUser.firstName,
                    "last_name": dataCreateNewUser.lastName,
                    "tel_no": dataCreateNewUser.telephone,
                    "email": dataCreateNewUser.email,
                    "company_name": dataCreateNewUser.companyName,
                    "line_api_token": dataCreateNewUser.lineApiToken,
                    "password": dataCreateNewUser.password,
                    "is_send_daily_report": dataCreateNewUser.isSendDailyReport,
                    "is_create_subdealer": dataCreateNewUser.isCreateSubDealer /* new requirement */
                })
            })
                .then(response => response.json())
                .then((data) => {
                    console.log(data)
                    this.setState({
                        showModalConfirmUserInformation: false,
                        isShowCreateNewDealer: false,
                        // isShowCreateNewDealer: true,
                        notification: true,
                        openList:true,
                    })
                })
                .then(setTimeout(() => {
                    this.setState({ notification: false });
                }, 3000))
                .then(() => {
                    this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize, apiName)
                })
                // .then(() => {window.scroll(0, 0);})
                .catch(function (err) {
                    console.log('err:', err);
                    // POST failed...
                });
        } else if (sideBarName === 'customerInfo') {
            fetch(`http://203.150.199.244/api/admin/updateCustomer/${dataSelectRow.user_id}`, {
                method: 'post',
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    // "user_id": user_id,
                    // "user_name": user_name,
                    "token": token
                },
                body: JSON.stringify({
                    "login_name": dataCreateNewUser.userName,
                    "first_name": dataCreateNewUser.firstName,
                    "last_name": dataCreateNewUser.lastName,
                    "tel_no": dataCreateNewUser.telephone,
                    "email": dataCreateNewUser.email,
                    "company_name": dataCreateNewUser.companyName,
                    "is_send_email_alert_overdue": dataCreateNewUser.isSendEmailAlertOverdue,
                    "is_auto_dispermit": dataCreateNewUser.isAutoDispermit,
                    "reseller_note": dataCreateNewUser.resellerNote,
                    "privileges": {
                        "is_view_tracking": dataCreateNewUser.isViewTracking,
                        "is_view_poi": dataCreateNewUser.isViewPoi,
                        "is_edit_poi": dataCreateNewUser.isEditPoi,
                        "is_view_history": dataCreateNewUser.isViewHistory,
                        "is_send_command": dataCreateNewUser.isSendCommand,
                        "is_view_report": dataCreateNewUser.isViewReport
                    }
                })
            })
                .then(response => response.json())
                .then(() => {
                    this.setState({
                        showModalConfirmUserInformation: false,
                        // isShowCreateNewDealer: true,
                        isShowCreateNewDealer: false,
                        notification: true,
                        openList:true,
                    })
                })
                .then(setTimeout(() => {
                    this.setState({notification: false});
                }, 3000))
                .then(() => {
                    this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize, apiName);
                })
                .catch(function (err) {
                    console.log('err:', err);
                    // POST failed...
                });
        } else if (sideBarName === 'employeeInfo') {
            fetch(`http://203.150.199.244/api/admin/updateEmployee/${dataSelectRow.user_id}`, {
                method: 'post',
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    // "user_id": user_id,
                    // "user_name": user_name,
                    "token": token
                },
                body: JSON.stringify({
                    "login_name": dataCreateNewUser.userName,
                    "first_name": dataCreateNewUser.firstName,
                    "last_name": dataCreateNewUser.lastName,
                    "tel_no": dataCreateNewUser.telephone,
                    "email": dataCreateNewUser.email,
                    "company_name": dataCreateNewUser.companyName,
                    "is_send_email_alert_overdue": dataCreateNewUser.isSendEmailAlertOverdue,
                    "is_auto_dispermit": dataCreateNewUser.isAutoDispermit,
                    "reseller_note": dataCreateNewUser.resellerNote
                })
            })
                .then(response => response.json())
                .then(() => {
                    this.setState({
                        showModalConfirmUserInformation: false,
                        // isShowCreateNewDealer: true,
                        isShowCreateNewDealer: false,
                        notification: true,
                        openList:true,
                    })
                })
                .then(setTimeout(() => {
                    this.setState({ notification: false });
                }, 3000))
                .then(() => {
                    this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize, apiName);
                })
                .catch(function (err) {
                    console.log('err:', err);
                    // POST failed...
                });
        } else if (sideBarName === 'adminInfo') {
            fetch(`http://203.150.199.244/api/admin/updateAdmin/${dataSelectRow.user_id}`, {
                method: 'post',
                headers: {
                    "Content-Type": "application/json; charset=utf-8",
                    // "user_id": user_id,
                    // "user_name": user_name,
                    "token": token
                },
                body: JSON.stringify({
                    "login_name": dataCreateNewUser.userName,
                    "first_name": dataCreateNewUser.firstName,
                    "last_name": dataCreateNewUser.lastName,
                    "tel_no": dataCreateNewUser.telephone,
                    "email": dataCreateNewUser.email,
                    "company_name": dataCreateNewUser.companyName,
                    "password": dataCreateNewUser.password
                })
            })
                .then(response => response.json())
                .then(() => {
                    this.setState({
                        showModalConfirmUserInformation: false,
                        isShowCreateNewDealer: true,
                        notification: true,
                        openList:true,
                    })
                })
                .then(setTimeout(() => {
                    this.setState({ notification: false });
                }, 3000))
                .then(() => {
                    this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize, apiName);
                })
                .catch(function (err) {
                    console.log('err:', err);
                    // POST failed...
                });
        }
    }

    onClickCancelDelete = (status) => {
        this.setState({ ShowDeleteRow: status });
    }

    onClickConfirmDelete = () => {

        AlertConfirm("ลบข้อมูล","คุณต้องการลบหรือไม่").then(isOk=>{
            if(isOk){
                const {
                    user_name,
                    user_id,
                    sideBarName,
                    token
                } = this.props;

                const { dataSelectRow } = this.state;
                fetch(`http://203.150.199.244/api/admin/deleteUser/${dataSelectRow.user_id}`, {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        // "user_id": user_id,
                        // "user_name": user_name,
                        "token": token
                    },
                    body: JSON.stringify({})
                })
                    // .then(response => response.json())
                    .then(response => { return checkStatus(response)})
                    .then((data) => {

                        if(data.RESULT_STATUS == "000")
                            AlertCommit(true,"ลบข้อมูลเรียบร้อยแล้ว");
                        else{
                            AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                        }

                        this.setState({ ShowDeleteRow: false})

                        if (sideBarName === 'dealerInfo') {
                                console.log('Delete dealer:::')
                                this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize, 'getDealerList')
                            } else if (sideBarName === 'customerInfo') {
                                console.log('Delete Customer:::')
                                this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize, 'getCustomerList')
                            } else if (sideBarName === 'employeeInfo') {
                                console.log('Delete Employee:::')
                                this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize, 'getEmployeeList')
                            } else if (sideBarName === 'adminInfo') {
                                console.log('Delete Admin:::')
                                this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize, 'getAdminList')
                            }
                    // .then(setTimeout(() => {
                    //     this.setState({ notification: false });
                    // }, 3000))
                    // .then(() => {

                        }
                    )
                    .catch(function (err) {
                        console.log('err:', err);
                        // POST failed...
                    });
        }
    });
    }

    convertDateFormat(date){

        let str = date.split(" ");
        let year = parseInt(str[2])+543;
        return str[0]+' '+str[1]+' '+year.toString()+' '+str[3]+' '+str[4];
    }

    onPasswordKeyPress(e){
        if (e.key === 'Enter') {
            console.log(e.key)
            this.onClickSearch();
        }
    }

    handleChange = (event) => {
        const { apiName } = this.state;
        var val = event.target.value;

        this.setState({
            search: val
        });

        const { sideBarName } = this.props;
        if (sideBarName === 'dealerInfo') {
            this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize,apiName);
        } else if (sideBarName === 'customerInfo') {
            this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize,apiName);
        } else if (sideBarName === 'employeeInfo') {
            this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize,apiName);
        } else if (sideBarName === 'adminInfo') {
            this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize,apiName);
        }
    }

    onClickSearch = () => {

        let name = this.state.search;
        const { apiName } = this.state;
        this.setState({search:name});
        const { sideBarName } = this.props;
        if (sideBarName === 'dealerInfo') {
            this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize,apiName);
        } else if (sideBarName === 'customerInfo') {
            this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize,apiName);
        } else if (sideBarName === 'employeeInfo') {
            this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize,apiName);
        } else if (sideBarName === 'adminInfo') {
            this.onPageSizeChange(this.state.currentPage, this.state.currentPageSize,apiName);
        }
        // this.onPageSizeChange(this.state.currentPage,this.state.currentPageSize);
    }

    onClickBack = () =>{
        // console.log('onClickBack')
        this.setState({
            openList : true,
            isShowCreateNewDealer:false,
        });
    }

    resetPassword = (userId) => {
        const { t } = this.props;
        //http://{server}/resetPassword/{id}
        console.log('userId:', userId);
        AlertConfirm(t('เปลี่ยนรหัสผ่าน'), "คุณต้องการเปลี่ยนรหัสรีเซ็ตรหัสผ่านหรือไม่").then(isOk=>{
            if(isOk){
                const {
                    user_name,
                    user_id,
                    token
                } = this.props;

                const { dataSelectRow } = this.state;
                fetch(`http://203.150.199.244/api/admin/resetPassword/${userId}`, {
                    method: 'post',
                    headers: {
                        "Content-Type": "application/json; charset=utf-8",
                        // "user_id": user_id,
                        // "user_name": user_name,
                        "token": token
                    },
                    body: JSON.stringify({})
                })
                // .then(response => response.json())
                    .then(response => { return checkStatus(response)})
                    .then((data) => {
                            if(data.RESULT_STATUS == "000")
                                AlertCommit(true,"รีเซ็ตเรียบร้อยแล้ว");
                            else{
                                AlertCommit(false,data.RESULT_STATUS + ": "+data.RESULT_MESSAGE);
                            }
                        }
                    )
                    .catch(function (err) {
                        console.log('err:', err);
                        // POST failed...
                    });
            }
        });
    }

    render(){
        const {
            isShowCreateNewDealer,
            isShowEdit,
            deviceList,
            currentPageSize,
            showModalConfirmUserInformation,
            notification,
            dataSelectRow,
            totalPage,
            openList
        }=this.state;

        const {
            t,
            userLevel,
            sideBarName,
            user_name,
            user_id,
            token,
            history
        } = this.props;

        let labelName = t('ข้อมูลตัวแทนจำหน่าย');
        if (sideBarName === 'customerInfo') {
            labelName = t('ข้อมูลลูกค้า');
        } else if (sideBarName === 'employeeInfo') {
            labelName = t('ข้อมูลพนักงาน');
        } else if (sideBarName === 'adminInfo') {
            labelName = t('ข้อมูลผู้ดูแลระบบ');
        }
        let rows = [];
        deviceList.map(device=>{
            rows.push(
                <tr key={device.user_id}>
                <td >{device.user_id}</td>
                <td >{device.login_name}</td>
                <td>{device.first_name} {device.last_name}</td>
                <td>{device.company_name}</td>
                <td>{(device.last_login_dtm) ? this.convertDateFormat(moment(device.last_login_dtm).format('lll')) : device.last_login_dtm}</td>
                {/*<td>{moment(device.last_login_dtm).local('th')}</td>*/}
                <td style={{textAlign:'right'}}><p data-placement="top" data-toggle="tooltip" title="Edit">
                    <button onClick={this.editeDevice.bind(this, device)} className="btn btn-primary btn-xs" data-title="Edit" data-toggle="modal"
                    data-target="#editDevice"  data-backdrop="static" data-keyboard="false"><span className="fa fa-pencil" /></button></p></td>
                <td><p data-placement="top" data-toggle="tooltip" title="Delete">
                    <button onClick={this.deleteDevice.bind(this, device)} className="btn btn-danger btn-xs" data-title="Delete" data-toggle="modal"
                    data-target="#deleteDevice" data-backdrop="static" data-keyboard="false"><span className="fa fa-trash" /></button></p></td>
                </tr>
            )

        });
        console.log('currentPageSize:', currentPageSize);
        return (
            <div className="gray-panel">
                { notification &&
                    <AlertBar />
                }

                <div className="col-md-12">
                        <h1 className="page-header"> <i className="fa fa-user" style={{color: '#7386D5'}} />&nbsp;{labelName}</h1>
                    </div>
                    <br />
                {
                    isShowCreateNewDealer &&
                    <FormCreateUserByRole
                        t={t}
                        onClose={this.onCloseCreateDealer.bind(this)}
                        userLevel={userLevel}
                        sideBarName={sideBarName}
                        onSubmit={this.onValidateComplete}
                        isShowEdit={isShowEdit}
                        labelName={labelName}
                        dataSelectRow={isShowEdit ? dataSelectRow : {}}
                        user_name={user_name}
                        user_id={user_id}
                        token={token}
                        isShowCreateNewDealer={isShowCreateNewDealer}
                        onBack={this.onClickBack}
                        history={history}
                        resetPassword={(userId) => this.resetPassword(userId)}
                    />

                }
                { showModalConfirmUserInformation &&
                <ModalConfirmUserInformation
                    onClickCancelUserInformation={this.onClickCancelUserInformation}
                    onClickConfirmUserInformation={this.onClickConfirmUserInformation}
                />
                }


                {
                    openList &&
                    <div>
                        <div className="form-inline form-group">
                            <label htmlFor="focusedInput" className="col-md-1">{t('ค้นหา')}</label>
                            <div  className="col-12 col-md-7 row" >
                                <input className="form-control col-7 col-md-5" style={{marginRight:5}} id="focusedInput" type="text" onChange={this.handleChange} onKeyUp={this.handleChange} onKeyPress={this.onPasswordKeyPress.bind(this)} />
                                <input type="button" className="btn btn-info" value="ค้นหา" onClick={this.onClickSearch} />
                            </div>
                        </div>

                     <div className="col-md-12 table-responsive">
                        <table  className="table table-bordred table-striped table-hover ">
                        <thead >
                            <tr>
                            <th>#</th>
                            <th style={{minWidth:100}}>{t('ผู้ใช้งาน')}</th>
                            <th style={{minWidth:100}}>{t('ชื่อ - นามสกุล')}</th>
                            <th style={{minWidth:100}}>{t('บริษัท')}</th>
                            <th style={{minWidth:100}}>{t('ใช้งานล่าสุด')}</th>
                            <th style={{textAlign:'right'}}>
                            <button onClick={this.createNewUserByRole.bind(this)}  className="btn btn-info btn-xs" data-title="Add" data-toggle="modal" data-target="#createNewUserByRole"><span className="fa fa-plus" /></button>
                            </th>
                            <th></th>
                            </tr></thead>
                        <tbody>
                            {rows}
                        </tbody>
                        </table>

                    </div>
                    <RCPagination
                        onSelect={this.onPageSelect.bind(this)}
                        onShowSizeChange={this.onPageSizeChange.bind(this)}
                        total={this.state.totalPage}
                        pageSize={this.state.currentPageSize}
                        currentPage={1}
                        currentPageSize={this.state.currentPageSize}/>
                    </div>
                }


                </div>
        );
    }
}

DealerInfo.propTypes = {
    userLevel: PropTypes.number.isRequired,
    user_name: PropTypes.string.isRequired,
    user_id: PropTypes.number.isRequired,
    sideBarName: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired,
    history: PropTypes.func.isRequired,
    objDeviceUserRelated: PropTypes.object,
}

export default withNamespaces('Menubar')(DealerInfo);



// WEBPACK FOOTER //
// ./src/app/view/components/AdminConfig/Content/DealerInfo.js